import { createContext } from "react";

const PagesContext = createContext<any>(undefined);
export default PagesContext;
